import moment from "moment";
export const timestamp = (value, format = "DD/MM/YYYY") => {
  return moment(value).format(format);
};

export const fromNow = value => {
  return moment(value).fromNow();
};
